class SoundEffects {
  constructor() {
    this.ctx = new (window.AudioContext || window.webkitAudioContext)();
  }

  playTone(freq, type, duration, vol) {
    if (this.ctx.state === 'suspended') this.ctx.resume();
    const osc = this.ctx.createOscillator();
    const gain = this.ctx.createGain();
    
    osc.type = type;
    osc.frequency.setValueAtTime(freq, this.ctx.currentTime);
    
    gain.gain.setValueAtTime(vol, this.ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.01, this.ctx.currentTime + duration);
    
    osc.connect(gain);
    gain.connect(this.ctx.destination);
    
    osc.start();
    osc.stop(this.ctx.currentTime + duration);
  }

  playDiceRoll() {
    // Quick rattling sound
    for(let i=0; i<5; i++) {
      setTimeout(() => {
        this.playTone(150 + Math.random()*200, 'triangle', 0.1, 0.5);
      }, i * 60);
    }
  }

  playMove() {
    // Pop sound
    this.playTone(400, 'sine', 0.1, 0.3);
  }

  playCash() {
    // Ka-ching!
    this.playTone(800, 'square', 0.1, 0.3);
    setTimeout(() => this.playTone(1200, 'square', 0.3, 0.4), 100);
  }

  playJail() {
    // Low buzzer
    this.playTone(100, 'sawtooth', 0.5, 0.5);
  }
}

export const sounds = new SoundEffects();
